/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import ForcProviderComponent from "core/components/forc/provider";
import File from "core/models/file";
import SemeiaSessionService from "core/services/session";
import DocumentEditionFormComponent from "..";
let DocumentEditionFormContent = (_class = class DocumentEditionFormContent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _initializerDefineProperty(this, "currentQuestions", _descriptor3, this);
  }
  setCurrentQuestions(questions) {
    this.currentQuestions = questions;
  }
  get changeset() {
    return this.args.forcComponent.changeset;
  }
  get providedForm() {
    return this.args.form;
  }

  /**
   * Callback function which is given
   * to the File upload component.
   * Will be called within the component
   * when upload is successful.
   */
  onSelected(file) {
    const files = this.changeset.get("files");
    const isFirstSelectedFile = Boolean(!files);
    if (isFirstSelectedFile) {
      this.changeset.set("files", [file]);
    } else {
      files.push(file);
      this.changeset.set("files", files);
    }
  }
  onDocumentTypeChange(key) {
    if (this.session.patient?.healthCentre?.disableBioForPatient && key == "bio") {
      this.router.transitionTo("patient-web.protected.bio-results.edition");
    } else this.changeset.set("documentType", key);
  }

  /**
   * Callback function which is given
   * to the File upload component.
   * Will be called within the component
   * when a file is deleted.
   */
  destroyFile(index) {
    const files = this.changeset.get("files");
    files?.splice(index, 1);
    this.changeset.set("files", files);
  }

  /**
   * File upload accepted types.
   * When upload button is clicked and
   * file explorer opens, only those
   * types would be uploadable.
   */
  get acceptedTypes() {
    return ["application/pdf", "image/jpeg", "image/jpg", "image/png", "application/rtf"];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "currentQuestions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "setCurrentQuestions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCurrentQuestions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDocumentTypeChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDocumentTypeChange"), _class.prototype), _class);
export { DocumentEditionFormContent as default };